import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	foundIn: {
		id: 'search-page.linked-results.found-in',
		defaultMessage: 'Found in',
		description: 'Label to indicate where the linked result was found',
	},
	similar: {
		id: 'search-page.linked-results.similar',
		defaultMessage: '{count} similar',
		description: 'Label for similar linked results',
	},
	related: {
		id: 'search-page.linked-results.related',
		defaultMessage: 'Related links',
		description: 'Label for related linked results',
	},
});
